<template>
<v-container fluid fill-height class="primary">
  <v-layout row align-center justify-center>
    <v-flex xs10 md6 lg4 xl3>
      <v-layout row>
        <v-flex>
          <v-card color="white">
            <v-card-title primary-title>
              <h3 class="headline">Cadastro Concluído</h3>
            </v-card-title>
            <v-card-text>
              <span>
                Cadastro efetuado com sucesso!
                Entraremos em contato assim que houver a confirmação do pagamento.
              </span>
            </v-card-text>
            <v-card-actions>
              <v-btn flat @click="$store.dispatch('logout')&&$router.push({name:'Login'})">
                Sair
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit" target="_blank"
                href="https://api.whatsapp.com/send?1=pt_BR&phone=5531995093600">
                Whatsapp
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
}
</script>

<style>

</style>